export default "__VITE_ASSET__IjE2ueaU__"